/**
 * FAQ collapsible button
 *
 */
function collapsable() {
    var coll = document.getElementsByClassName("collapsible");
    var i;
    for (i = 0; i < coll.length; i++) {
        coll[i].addEventListener("click", function () {
            this.classList.toggle("active");
            var content = this.nextElementSibling;
            if (content.style.maxHeight) {
                content.style.maxHeight = null;
            } else {
                content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    }
}

/**
 * Custom order on click event
 *
 */
function custom_order_form_submit() {

    $('#CustomOrderFormSubmit').bind('click', function (event) {

        if (event) event.preventDefault();
        var name = $('#ContactFormName').val();
        var company = $('#ContactFormCompany').val();
        var email = $('#ContactFormEmail').val();
        var phone_number = $('#ContactFormPhone').val();
        var message = $('#ContactFormMessage').val();
        var obj = {};
        obj['name'] = name;
        obj['email'] = email;
        obj['company'] = company;
        obj['phone_number'] = phone_number;
        obj['message'] = message;

        submit(obj);

    });
}

/**
 * Submit custom order
 *
 * @param {*} data
 */
function submit(data) {

    $.ajax({
        method: "POST",
//         url: "https://email.streamlinedcampaigns.com/api/bulletproofvest/custom-order",
        url: "https://api.streamlinedcampaigns.com/bulletproofvest-custom-order",
        data: JSON.stringify(data),
        contentType: "application/json",
        dataType: 'json',
        success: function (data) {
            $(".input-full").val('');
            toastr.success(data.message, 'Form Sent');
        },
        error: function (jqXhr, json, errorThrown) {
            var errors = jqXhr.responseJSON.errors;
            for (var i in errors) {
                toastr.error(errors[i].param + ': ' + errors[i].msg, 'Form Error!');
            }
        }
    });
}

/**
 * Products page image slider
 *
 */
function productSlider() {
    $('.product-slider').slick({
        dots: true,
        infinite: true,
        adaptiveHeight: true
    })
    
}


/**
 * Init
 *
 */
function init() {
    collapsable();
    custom_order_form_submit();
    productSlider();
}

$(document).ready(init);

